export default __webpack_public_path__ + "static/banner-customer-delight-924e0ff0ed7aa12b4a56e55b753307bf.jpeg";